module.exports = __webpack_public_path__ + "static/media/a-1-a.57b3779d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/accessroies/a-1-a.jpg
// module id = 1088
// module chunks = 33